import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import ListSubheader from 'material-ui/List/ListSubheader';
import List from 'material-ui/List';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1040,
    background: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    margin: '0 auto',
  },
});

const PinnedSubheaderList = props => {
  const { classes, title, items, renderItem } = props;

  return (
    <List className={classes.root} subheader dense>
      {title && <ListSubheader>{title}</ListSubheader>}
      {items.map(renderItem)}
    </List>
  );
};

PinnedSubheaderList.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  items: PropTypes.array,
  renderItem: PropTypes.func.isRequired,
};

PinnedSubheaderList.defaultProps = {
  items: [],
};

export default withStyles(styles)(PinnedSubheaderList);



// WEBPACK FOOTER //
// ./src/modules/common/components/list/PinnedSubHeaderList.js